module.exports = __webpack_public_path__ + "img/csr_swiper_04_04.1895023b.jpg";